import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import { baseURL } from '../base_url';
import { PuffLoader } from 'react-spinners';
import { Form, Col, Row } from 'react-bootstrap';
import { Button, Container } from '@mui/material';
import { IoIosRemoveCircle } from "react-icons/io";


const RemoveFleet = () => {
  const [loading, setLoading] = useState(false);
  const [vinNumber, setVinNumber] = useState('');
  
  const handleSubmitForm = (e) => {
    if(vinNumber.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please enter VIN Number.'})
      return;
    }
    setLoading(true);
    axios.post(baseURL + "/remove_vin_contract", {
      'vin': vinNumber.toString().trim(),
      }).then((res) => {
        setLoading(false);
        if (res.data === 'successfully'){
          Swal.fire({icon: 'success',
            title: 'Success',
            text: vinNumber.toString() + " is successfully removed from Stellantis."
          })
          setVinNumber('');
        }else{
          Swal.fire({icon: 'warning',
            title: 'Warning',
            text: vinNumber.toString() + " - Please check the status of this VIN once again in Fetch Fleet Module."
          })
          setVinNumber('');
        }
        // else{
        //   Swal.fire({icon: 'error',
        //     title: 'Failed',
        //     text: "Something went wrong please try again."
        //   })
        // }
    })
  }
  return(
    <div className='body_class'>
      {loading ? (
          <div className="loader-overlay">
              <div className="loader">
              <PuffLoader color="#00308F" loading={true} size={200} />
              </div>
          </div>
      ) : ("")}
        <div className='container-fluid'>
            <h4>Remove vehicle from Stellantis</h4>
            <div className='mt-4'>
            <div className='container-fluid'>
            <Form>
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                  <Form.Label column sm="2">
                    VIN Number *
                  </Form.Label>
                  <Col sm="5">
                    <Form.Control type='text' value={vinNumber} onChange={(e)=>setVinNumber(e.target.value)} placeholder='Enter VIN Number' />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                  <Form.Label column sm="2"></Form.Label>
                  <Col sm="5">
                  <Button variant="contained" color='error' onClick={handleSubmitForm}><IoIosRemoveCircle size={24}/>&nbsp;Remove</Button>
                  </Col>
                </Form.Group>
              </Form>
            </div>
            </div>
        </div>
    </div>
  )  
}

export default RemoveFleet;